<template>
  <!-- <van-tabbar v-model="active" @change="onChange" v-if="showTabbar" z-index="2">
    <van-tabbar-item icon="home-o">首页</van-tabbar-item>
    <van-tabbar-item icon="chat-o">客服</van-tabbar-item>
    <van-tabbar-item icon="user-o">我的</van-tabbar-item>
  </van-tabbar> -->
    <!-- <router-view></router-view> -->
    <router-view v-slot="{ Component, route }" @child-data="handleChildData">
    <keep-alive :include="['ListPage']" :max="3" @child-data="handleChildData">
      <component 
        :is="Component" 
        v-if="route.meta.keepAlive"
        :key="route.fullPath" 
      />
    </keep-alive>
    <component 
      :is="Component" 
      v-if="!route.meta.keepAlive"
      :key="route.fullPath"
    />
  </router-view>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      showTabbar: true,
    }
  },
  created() {
    if (this.userinfo) {
      this.showTabbar = true;
    } else {
      this.showTabbar = false;
    }
  },
  mounted() {
    // 禁止页面缩放
    const viewportMeta = document.querySelector('meta[name="viewport"]');
    if (viewportMeta) {
      viewportMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
    } else {
      const meta = document.createElement('meta');
      meta.name = 'viewport';
      meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  },
  methods: {
    onChange(index) {
      this.active = index;
      if (this.active == 0) {
        this.$router.replace({ name: "Home" });
      }
      else if (this.active == 1) {
        this.$router.replace({ name: "Kefu" });
      }
      else if (this.active == 2) {
        this.$router.replace({ name: "Wode" });
      }
    },
    handleChildData(data) {
      if(data == "yincang")
      {
        this.showTabbar = false;
      }
      else
      {
        this.showTabbar = true;
      }
      console.log(data); // 输出: 这是子组件的数据
    },
    handleChildTitle(data){
      document.title = data;
      console.log(data);
    },
  }
};

</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-image: linear-gradient(135deg, #e3edfb, #ffffff,#fff5f5);
  padding: 0px;
} */
#app {
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-image: url('https://m.xuxug.com/indexh5/img/indextbg.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top center;
  padding: 0px;
}
</style>
